import { z } from 'zod';
import { BILLING_TYPE_SCHEMA } from '@schuettflix/interfaces';

export const PaymentTermsSettingsSchema = z.discriminatedUnion('billingMethod', [
    z.object({
        billingMethod: BILLING_TYPE_SCHEMA.extract(['CREDIT_NOTE', 'INVOICE']),
        paymentTermId: z.number(),
    }),
    z.object({
        billingMethod: BILLING_TYPE_SCHEMA.extract(['PARTNER_INVOICE']),
        paymentTermId: z.null(),
    }),
]);

export const FinanceSettingsSchema = z
    .object({
        debtorOrganizationId: z.number(),
        creditorOrganizationId: z.number(),
        billingText: z.string().max(255).nullable(),
    })
    .and(PaymentTermsSettingsSchema);

export type FinanceSettings = z.infer<typeof FinanceSettingsSchema>;
export type PaymentTermsSettings = z.infer<typeof PaymentTermsSettingsSchema>;
